import { initialFormState } from '../../form/form/types/state';
import { defaultTextInputModalData } from './data';
export const defaultTextInputModalState = Object.assign(Object.assign({}, initialFormState), { formData: defaultTextInputModalData });
//# sourceMappingURL=state.js.map